import { NodeEditor } from 'rete';

import ReteInput, {
  ReteInputParams,
} from 'pipelines/services/rete/controls/input';

import {
  TrackableListPropertyInput,
  TrackableListPropertyInputProps,
} from 'pipelines/components/TrackableProperties';
import { TrackableObjectType } from 'types/trackables';

type TrackableListInputParams = Omit<ReteInputParams, 'type'> & {
  trackableListObjectTypes?: TrackableObjectType | TrackableObjectType[];
};

export default class ReteTrackableListsInput extends ReteInput<TrackableListPropertyInputProps> {
  constructor(
    editor: NodeEditor,
    key: string,
    params: TrackableListInputParams = {}
  ) {
    const { trackableListObjectTypes, ...rest } = params;
    super(editor, key, { ...rest, type: 'string', inputType: 'select' });
    this.props.trackableListObjectTypes = trackableListObjectTypes;
  }

  get component() {
    return TrackableListPropertyInput;
  }
}
